import { useMemo } from 'react';
import { MedVoxTask } from '../../../models/MedVox/MedVoxTask';
import { AudioSrc } from '../useMedVoxTasks/types';
import { MedVoxCall } from '../../../models/MedVox/MedVoxCall';
import ExpandableRowElement from '../../../components/Tasks/ExpandableRowElement/ExpandableRowElement';

export const useAudioPlayers = (record: MedVoxTask, audioSrc?: AudioSrc) => {
  return useMemo(() => {
    return record.calls?.map((call: MedVoxCall, index: number) => {
      return (
        <ExpandableRowElement
          call={call}
          index={index}
          audioSrc={audioSrc}
          key={index}
        />
      );
    });
  }, [record.calls, audioSrc]);
};
